"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _popup = _interopRequireDefault(require("../popup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ActionSheet = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ActionSheet, _PureComponent);

  var _super = _createSuper(ActionSheet);

  function ActionSheet() {
    var _this;

    (0, _classCallCheck2.default)(this, ActionSheet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.renderActions = function (action, index) {
      var prefixCls = _this.props.prefixCls;
      var actionCls = (0, _classnames3.default)("".concat(prefixCls, "__item"), action.className, (0, _defineProperty2.default)({}, "".concat(prefixCls, "__item--").concat(action.theme), !!action.theme));
      return /*#__PURE__*/_react.default.createElement("div", {
        key: +index,
        className: actionCls,
        onClick: action.onClick
      }, action.text);
    };

    _this.renderCancel = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          onCancel = _this$props.onCancel,
          cancelText = _this$props.cancelText,
          locale = _this$props.locale;
      return typeof onCancel === 'function' && /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__cancel")
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__item"),
        onClick: onCancel
      }, cancelText || locale.cancelText));
    };

    return _this;
  }

  (0, _createClass2.default)(ActionSheet, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          spacing = _this$props2.spacing,
          visible = _this$props2.visible,
          onMaskClick = _this$props2.onMaskClick,
          actions = _this$props2.actions,
          destroy = _this$props2.destroy;
      var cls = (0, _classnames3.default)(prefixCls, (0, _defineProperty2.default)({}, "".concat(prefixCls, "--spacing"), spacing));
      return /*#__PURE__*/_react.default.createElement(_popup.default, {
        className: className,
        visible: visible,
        onMaskClick: onMaskClick,
        destroy: destroy
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: cls
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "__actions")
      }, actions.map(this.renderActions)), this.renderCancel()));
    }
  }]);
  return ActionSheet;
}(_react.PureComponent);

exports.default = ActionSheet;
ActionSheet.defaultProps = {
  prefixCls: 'za-action-sheet',
  visible: false,
  spacing: false,
  actions: [],
  destroy: true
};